module.exports = __webpack_public_path__ + "img/logo-dostartu.d024f096.svg";